_collow.components.Profile = class Profile extends _collow.components.Base {
  root;
  elements;
  params;
  allowedCourses;

  courseData = JSON.parse(localStorage.progressJson);

  constructor(root, elements, params) {
    super();
    this.root = root;
    this.elements = elements;
    this.params = params;

    this.listen(document.body, "_collow.logout", this.redirectHomePage);
    this.listen(
      document.body,
      "_collow-not-logged-in",
      () => (window.location.pathname = "login")
    );
    const progressJson = localStorage.getProgressJson();

    if (!progressJson) return;

    const fullname = () => {
      const firstname = progressJson.firstname || '';
      const prefix = progressJson.prefix || '';
      const lastname = progressJson.lastname || '';


      return `${firstname} ${prefix} ${lastname}`.trim();
    };
    const getStudyPointsEarned = () => {
      let points = 0;
      if (progressJson.course_registrations && progressJson.course_registrations.length > 0) {
        for (const courseRegistration of progressJson.course_registrations) {
          if (courseRegistration.status === 2 && courseRegistration.course.study_points > 0) {
            points += courseRegistration.course.study_points
          }
        }
      }
      return points;
    };
    this.fetchAllowedCourses().then(() => {
      this.displayProgressBar()
      this.displayUserFullName(fullname());
      this.displayUserEmail(progressJson.email);
      this.displayStudyPointsEarned(getStudyPointsEarned());
      this.displayCourses(localStorage.getCourses());
      this.certificateButton();
      this.courseLinks();
    })
  }
  displayUserFullName = (userName) => {
    this.elements.userName.innerHTML = userName;
  };
  displayUserEmail = (email) => {
    this.elements.userEmail.innerHTML = email || ''
  }
  displayStudyPointsEarned = (study_points_earned) => {
    this.elements.userStudyPointsEarned.innerHTML = study_points_earned || '0'
  }

  displayCourses = (registrations) => {
    let excludedProjects = ["Collow"];

    const template = this.elements.courseTemplate;
    registrations.forEach((registration) => {
      const courseId = registration.course["unique_identifer"];
      let nextLink
      let linkText

      if (excludedProjects.includes(this.params.project)) {
        nextLink = this.allowedCourses.includes(courseId) ? registration["next_element"] : `course-introduction/${courseId}`;
        linkText = this.allowedCourses.includes(courseId) ?
          registration.status == 1
            ? this.elements.courseTemplate.dataset.continueText
            : this.elements.courseTemplate.dataset.finishedText : this.elements.courseTemplate.dataset.checkoutText
      } else {
        nextLink =
          registration["next_element"] ?? `course-introduction/${courseId}`;
        linkText =
          registration.status == 1
            ? this.elements.courseTemplate.dataset.continueText
            : this.elements.courseTemplate.dataset.finishedText;
      }

      const registrationState =
        registration.status == 1
          ? "data-profile-course-progress"
          : "data-profile-course-finished";

      const courseTemplate = template.cloneNode(true).content.querySelector('.my-courses__course')

      const templateName = courseTemplate.querySelector('.my-courses__coursename')
      const templateButton = courseTemplate.querySelector('.my-courses__continue')

      courseTemplate.setAttribute("data-course", courseId)
      courseTemplate.setAttribute("registration-state", registrationState)
      templateName.innerHTML = registration.course["course_name"]
      templateButton.setAttribute("href", nextLink)
      templateButton.textContent = linkText
      templateButton.setAttribute("href", nextLink)

      this.elements.coursesContainer.appendChild(courseTemplate);
    });
  };


  displayProgressBar = async () => {
    const promises = [];

    for (let i = 0; i < this.courseData.course_registrations.length; i++) {
      const courseId = this.courseData.course_registrations[i].course_id;
      const courseRegistrationId = this.courseData.course_registrations[i].course_registration_id;

      const getCourseStepsPromise = fetch(this.params.path + `/course/steps?course_id=${courseId}`, {
        method: "get",
        headers: {},
      }).then(response => response.json());

      const getCompletedStepsPromise = fetch(this.params.path + `/course_registration/${courseRegistrationId}/elements_done`, {
        method: "get",
        headers: {
          Authorization: localStorage.getItem("token")
        }
      }).then(response => response.json());

      promises.push(Promise.all([getCourseStepsPromise, getCompletedStepsPromise, i]));
    }

    const results = await Promise.all(promises);

    results.forEach(([allCourseSteps, completedCourseSteps, i]) => {
      if (this.courseData.course_registrations[i].status === 2) {
        document.getElementsByClassName('completion-bar-component')[i].setAttribute("value", 100);
        document.getElementsByClassName('completion_percentage')[i].textContent = `${this.params.completedtranslation}`;
        document.getElementsByClassName('completion_steps_text')[i].textContent = '';
      } else {
        let cleanCompletedCourseSteps = [];
        let collectedIds = [];
        completedCourseSteps.forEach(step => {
          if ((step.status === 1) && !(collectedIds.includes(step.course_element_id))) {
            cleanCompletedCourseSteps.push(step);
            collectedIds.push(step.course_element_id);
          }
        });

        document.getElementsByClassName('completion-bar-component')[i]?.setAttribute("max", allCourseSteps.length);
        document.getElementsByClassName('completion-bar-component')[i].setAttribute("value", cleanCompletedCourseSteps.length);
        document.getElementsByClassName('completion_steps_text')[i].textContent = `${cleanCompletedCourseSteps.length}/${allCourseSteps.length} ${this.params.stepstranslation}`;
        document.getElementsByClassName('completion_percentage')[i].textContent = `${((cleanCompletedCourseSteps.length / allCourseSteps.length) * 100).toFixed(1)}%`;
      }
    });
  }

  certificateButton = () => {
    const courseInHTML = (document.getElementsByClassName('my-courses__coursename'))
    const courses = localStorage.getCourses()
    for (let i = 0; i < this.courseData.course_registrations.length; i++) {
      if ((courseInHTML[i]?.textContent.trimEnd() === this.courseData.course_registrations[i].course.course_name) &&
        (this.courseData.course_registrations[i].status === 2)) {
        const certificateButton = document.getElementsByClassName('button-1 my-courses__continue')[i]
        certificateButton.textContent = this.params.buttontext
        certificateButton.removeAttribute("href")
        certificateButton?.setAttribute("data-certificate", '')
        certificateButton.addEventListener("click", () => this.getCertificate(i))
        if (courses[i].course.certificate != "Yes") {
          certificateButton.setAttribute("hidden", '')
        }
      }
    }
  }

  getCertificate = (i) => {
    const registrationId = JSON.parse(localStorage.getItem("progressJson"))[
      "course_registrations"
    ][i]["course_registration_id"];

    fetch(
      this.params.path + `/course_registration/${registrationId}/certificate`,
      {
        method: "get",
        headers: {
          Authorization: window.localStorage.getItem("token"),
        },
      }
    )
      .then(async (res) => {
        if (!res.ok) {
          const resJson = await res.json();
          const { detail } = resJson;
          if (
            detail?.["error_code"] ==
            "course_registration_no-name-for-certificate"
          ) {
            this.invalidCertificateCall("name");
          }
          else {
            this.invalidCertificateCall("general");
          }
        }
        return res.blob();
      })
      .then((blob) => {
        const file = window.URL.createObjectURL(blob);
        window.open(file, "_blank");
      })
  };

  // Adds a link to the course names elements that brings the user to the course into
  courseLinks = async () => {
    const allCourseTexts = document.getElementsByClassName("my-courses__coursename")
    for (let i = 0; i < allCourseTexts.length; i++) {
      allCourseTexts[i].setAttribute("href", "/course-introduction/" + this.courseData.course_registrations[i].course.unique_identifer)
    }
  }


  redirectHomePage = () => {
    window.location.href = "/";
  };

  invalidCertificateCall = (error) => {
    this.dispatch(this.root, "_collow.popup", { type: "open", error });
  };

  fetchAllowedCourses = () => {
    return fetching(this.params.path + "/course/allowed_courses")
      .then((res) => {
        let excludedProjects = ["Collow"];

        this.allowedCourses = res.map(course => course.unique_identifer);
      })
  }
};